import { useCoins } from '@starsoft/common/api';
import BaseSection from '../BaseSection';
import Coins from './Coins';

export default function CoinsSection() {
  const { cryptoCoins, error } = useCoins();

  if (error || cryptoCoins?.length === 0) {
    return null;
  }

  return (
    <BaseSection title="allowed_coins">
      <Coins />
    </BaseSection>
  );
}
